import DiagnosticsListView from '../common/DiagnosticsListView'
import { ECG_LIST_CONFIG } from '../common/configs'

const EcgListPage = () => <DiagnosticsListView config={ECG_LIST_CONFIG} />

export default EcgListPage
